import React, { useState, useEffect } from 'react';
import { transferApi } from 'helpers/api/transfer';
import { SubRows } from './SubRows';

const SubRowAsync = ({ row, rowProps, visibleColumns, onClick }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      const {
        data: { documents },
      } = await transferApi.getTransferActAdditionalInfo(row.original.actID1C);
      setData(documents);
      setLoading(false);
    }, 1);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <SubRows
      row={row}
      rowProps={rowProps}
      visibleColumns={visibleColumns}
      data={data}
      loading={loading}
      onClick={onClick}
    />
  );
};

export { SubRowAsync };
